module.exports = __webpack_public_path__ + "img/slovakia.2aaa4484.svg";